import { render, staticRenderFns } from "./OrdersList.vue?vue&type=template&id=c3998288&scoped=true&"
import script from "./OrdersList.vue?vue&type=script&lang=ts&"
export * from "./OrdersList.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersList.vue?vue&type=style&index=0&id=c3998288&lang=scss&scoped=true&"
import style1 from "./OrdersList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3998288",
  null
  
)

export default component.exports